import { Header } from '@/components/Header';
import { ModeratePosts } from '@/pages/ModeratePosts';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { useNotificationOpenTracking } from '@/lib/hooks/useUserNotifications';

const moderatePostsSearchSchema = z.object({
  notificationId: z.string().optional(),
});

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/moderate-posts'
)({
  validateSearch: moderatePostsSearchSchema,
  component: ModeratePostsPage,
});

function ModeratePostsPage() {
  const navigate = useNavigate();
  const { notificationId } = Route.useSearch();

  useNotificationOpenTracking(notificationId, () => {
    navigate({
      to: '/admin/moderate-posts',
      replace: true,
    });
  });

  return (
    <>
      <Header enableBack additionalClasses="bg-slate-700" />
      <ModeratePosts />
    </>
  );
}
